import assert from './assert'

export const sourceSchemaPath = (args, hasSchema2 = true) => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  const schemaPathFragment = hasSchema2 ? 'schema2' : 'schema'
  const path = `/${args.workspaceSlug}/sources/${
    args.sourceSlug
  }/${schemaPathFragment}`

  if (!args.eventType && args.eventName) {
    throw new Error(
      `eventType must be provided for provided eventName: ${args.eventName}`
    )
  }

  if (args.eventType && !args.eventName) {
    return `${path}/${args.eventType}`
  }

  if (args.eventType && args.eventName) {
    return `${path}/${args.eventType}/${args.eventName}`
  }

  return path
}

export const legacySourceSchemaPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return sourceSchemaPath(args, false)
}

export const sourceSchemaEventsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return sourceSchemaPath({
    ...args,
    eventType: 'events',
    eventName: args.eventId
  })
}

export const sourceSchemaIdentifyPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return sourceSchemaPath({ ...args, eventType: 'identify' })
}

export const sourceSchemaGroupPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return sourceSchemaPath({ ...args, eventType: 'group' })
}

export const sourceSchemaViolationsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return sourceSchemaPath({ ...args, eventType: 'violations' })
}

export const sourceSchemaViolationSummaryPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'eventId'])
  const { eventId } = args
  const queryParams = args.timeframe ? `?timeframe=${args.timeframe}` : ''
  return `${sourceSchemaPath({
    ...args,
    eventType: 'violations'
  })}/${eventId}${queryParams}`
}

export const trackingPlanPath = args => {
  assert(args, ['workspaceSlug'])
  const urlParam = args.resourceId ? `/${args.resourceId}` : ''
  return `/${args.workspaceSlug}/protocols/tracking-plans${urlParam}`
}

export const trackingPlanDataValidationPath = args => {
  assert(args, ['workspaceSlug', 'trackingPlanId'])
  return `/${args.workspaceSlug}/protocols/data-validation/${
    args.trackingPlanId
  }`
}

export const trackingPlanConnectSourcePath = args => {
  assert(args, ['workspaceSlug', 'trackingPlanId'])
  return `/${args.workspaceSlug}/protocols/tracking-plans/connect/${
    args.trackingPlanId
  }`
}

export const sourceSchemaPathForEvent = (
  hasSchema2,
  workspaceSlug,
  sourceSlug,
  event
) => {
  const type = event.normalized.type

  const args = {
    workspaceSlug,
    sourceSlug,
    hasSchema2,
    eventType: type
  }

  if (hasSchema2) {
    if (type === 'track' || type === 'page' || type === 'screen') {
      args.eventType = 'events'
    }
  } else {
    if (type === 'track') {
      args.eventType = 'tracks'
      args.eventName = encodeURIComponent(event.summary)
    }
  }

  return sourceSchemaPath(args, hasSchema2)
}
